import React from 'react'
import Centered from 'shared/ui/Centered'
import Heading from 'shared/ui/Heading'
import { Hero, HeroPrimaryContent } from '../ui/Hero'
import TeamBio from '../ui/TeamBio'
import { SlantBackground } from '../ui/SlantBackground'
import team from '../data/team'

export default function Contact() {
  return (
    <div className="spacing-giant">
      <Hero>
        <HeroPrimaryContent>
          <div>
            <Heading className="text-color-blue">
              Say hello to our team{' '}
              <span role="img" aria-label="hand wave">
                👋
              </span>
            </Heading>
          </div>
        </HeroPrimaryContent>
      </Hero>

      <SlantBackground verticalOffset={-6} shallowSlant />

      <Centered maxWidth="750px">
        <div className="spacing-large">
          {team.map((teamMember) => {
            return <TeamBio key={teamMember.id} id={teamMember.id} url={`/team/${teamMember.id}`} />
          })}
        </div>
      </Centered>
    </div>
  )
}
